let init = {
    removeAdsList: {
        removeAdsListTable: [],
        limit: 5,
        page: 0,
        totalDocs: 0,
        totalPages: 0
    },
}

const removeAdsReducer = (state = init, { type, payload }) => {
    switch (type) {
        case 'GET_REMOVE_ADS_LIST': {
            return {
                ...state,
                removeAdsList: {
                    removeAdsListTable: payload?.docs || [],
                    totalDocs: payload?.totalDocs || 0,
                    totalPages: payload?.totalPages || 0,
                    limit: payload?.limit || 5,
                    page: (payload?.page || 1) - 1
                }
            }
        }
        case 'ADD_REMOVE_ADS_LIST': {
            return {
                ...state,
                removeAdsList: {
                    ...state.removeAdsList,
                    removeAdsListTable: [payload, ...state.removeAdsList.removeAdsListTable],
                    totalDocs: Number(state.removeAdsList?.totalDocs) + 1,
                }
            }
        }
        case 'UPDATE_REMOVE_ADS_LIST': {
            let temp = { ...state }
            let index = temp.removeAdsList.removeAdsListTable.findIndex((item) => item._id === payload._id)
            if (index > -1) {
                temp.removeAdsList.removeAdsListTable[index] = payload
            }
            return temp
        }
        case 'DELETE_REMOVE_ADS': {
            let filters = state.removeAdsList.removeAdsListTable.filter(item => item._id !== payload.removeAdsPackageId)
            return {
                ...state,
                removeAdsList: {
                    ...state.removeAdsList,
                    removeAdsListTable: filters,
                    totalDocs: Number(state.removeAdsList?.totalDocs) - 1,
                }
            }
        }
        default: {
            return state
        }
    }
}

export default removeAdsReducer;
